import { render } from "./ManageMFA.vue?vue&type=template&id=0298385c"
import script from "./ManageMFA.vue?vue&type=script&lang=js"
export * from "./ManageMFA.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__